// startup
// Load entry module and return exports
// This entry module depends on other loaded chunks and execution need to be delayed
var __webpack_exports__ = __webpack_require__.O(undefined, ["vendors-node_modules_gsap_index_js","vendors-node_modules_splidejs_splide_dist_js_splide_esm_js"], () => (__webpack_require__("./src/js/home.js")))
__webpack_exports__ = __webpack_require__.O(__webpack_exports__);
